<template>
  <div>
    <pc-dialog title="邀请好友" :visible.sync="dialogVisible" @close="close" @confirm="close">
      <template #content>
        <div class="main">
          <div class="way">
            <span>方法一：分享邀请码给好友，预约时输入该邀请码。</span>
            <div class="code"><span>{{ inviteCode }}</span></div>
          </div>
          <div class="way">
            <span>方法二：复制专属链接并分享给好友。</span>
            <div class="box">
              <input class="link" type="text" :value="inviteUrl" readonly />
              <div class="copy-btn" @click="copy(inviteUrl)">复制</div>
            </div>
          </div>
        </div>
      </template>
    </pc-dialog>
  </div>
</template>

<script>
import PcDialog from '@/views/pc/components/dialog/Index.vue'

import { inviteCode } from '@/api/system.api.js'

import { mapMutations } from 'vuex'

export default {
  name: 'PcInvitationDialog',
  components: {
    PcDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { 
      dialogVisible: false,
      inviteCode: '',
      inviteUrl: '',
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val

      if (val) this.getInviteCode()
    }
  },
  methods: {
    ...mapMutations(['setTipsDialog']),
    close() {
      this.$emit('update:visible', false)
    },
    copy(text) {
      this.$copyText(text)
      this.setTipsDialog({ visible: true, tips: '复制成功' })
      this.close()
    },
    async getInviteCode() {
      // 防止当前阶段还未加载出来时触发预约
      if (this.stage !== 0 && this.stage !== 1) {
        this.tips = '请刷新页面后重试~'
        this.setTipsDialog({ visible: true, tips: this.tips })
        return false
      }

      const params = {
        token: this.user.token,
        type: this.stage == 0 ? 2 : 3, // 根据阶段类型判断是邀请预约
      }
      await inviteCode(params)
        .then((res) => {
          if (res.code == 0) {
            this.inviteCode = res.data.inviteCode
            this.inviteUrl = res.data.inviteUrl
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 30px;
  min-height: 300px;
  font-size: 18px;
  white-space: pre-wrap;

  .way {
    margin-bottom: 40px;
  }

  .code {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;

    span {
      font-size: 24px;
    }
  }

  .box {
    display: flex;
    align-items: center;
    margin-top: 10px;
  }

  .link {
    flex: 1;
    padding: 10px;
    height: 42px;
    font-size: 20px;
    background: #fdfcf7;
    border: 1px solid #e2d6cb;
    outline: none;
  }

  .copy-btn {
    margin-left: 10px;
    padding: 0 10px;
    height: 40px;
    line-height: 38px;
    color: #fff;
    background: #388176;
    border: 1px solid #388176;
    cursor: pointer;
  }
}
</style>